import { localeFullCode } from '../../../shared/useUtils';
import { TrustPilotBannerStyle } from '../../../styles/components/common/blocks';

export interface ITrustPilotBannerProps {
  locale: string;
}

const TrustPilotBanner = (props: ITrustPilotBannerProps) => {
  return (
    <div className={TrustPilotBannerStyle['trust-pilot-banner']}>
      {/* TrustBox widget - Mini */}
      <div
        className="trustpilot-widget"
        data-locale={localeFullCode(props.locale)}
        data-template-id="5419b6ffb0d04a076446a9af"
        data-businessunit-id="57583e6f0000ff00058f82f6"
        data-style-height="20px"
        data-style-width="100%"
        data-theme="dark"
        data-token="cca449f9-cfc1-4b84-8db7-c222cd8217e8">
        <a
          href={`https://${
            props.locale !== 'en' ? props.locale : 'www'
          }.trustpilot.com/review/igerent.com`}
          target="_blank"
          rel="noopener">
          Trustpilot
        </a>
      </div>
      {/* End TrustBox widget */}
    </div>
  );
};

export default TrustPilotBanner;
